/* Beeswax: prev / next arrows laid over the product image + proof stickers pinned to the image.
   Both are measured against the actual media box (.product-media-container), not the slide,
   so they stay on the photo whatever the aspect ratio / media_fit / viewport. */
(() => {
  const desktop = () => window.matchMedia('(min-width: 750px)').matches;

  const init = (nav) => {
    if (nav.dataset.bwReady) return;
    nav.dataset.bwReady = '1';
    const gallery = nav.closest('media-gallery');
    const viewer = nav.closest('slider-component');
    const list = viewer && viewer.querySelector('.product__media-list');
    if (!gallery || !list) return;

    const items = () => [...list.querySelectorAll('.product__media-item[data-media-id]')];
    const current = () => {
      const all = items();
      if (desktop()) {
        const i = all.findIndex((li) => li.classList.contains('is-active'));
        return i >= 0 ? i : 0;
      }
      let best = 0; let dist = Infinity;
      all.forEach((li, i) => { const d = Math.abs(li.offsetLeft - list.scrollLeft); if (d < dist) { dist = d; best = i; } });
      return best;
    };
    const mediaBox = (li) => (li && (li.querySelector('.product-media-container') || li)) || null;

    // pin the arrow row to the visible image, and the stickers to the first image
    const place = () => {
      const all = items(); if (!all.length) return;
      const box = mediaBox(all[current()]);
      if (box) {
        const b = box.getBoundingClientRect(); const v = viewer.getBoundingClientRect();
        if (b.width > 0) {
          nav.style.left = (b.left - v.left) + 'px';
          nav.style.top = (b.top - v.top) + 'px';
          nav.style.width = b.width + 'px';
          nav.style.height = b.height + 'px';
          nav.style.right = 'auto';
        }
      }
      const st = list.querySelector('.bw-stickers');
      if (st) {
        const li = st.closest('.product__media-item'); const sb = mediaBox(li);
        const r = sb && sb.getBoundingClientRect(); const lr = li.getBoundingClientRect();
        if (r && r.width > 0) {
          st.style.left = (r.left - lr.left) + 'px';
          st.style.top = (r.top - lr.top) + 'px';
          st.style.width = r.width + 'px';
          st.style.height = r.height + 'px';
        }
      }
    };
    place();
    if (window.ResizeObserver) new ResizeObserver(place).observe(list);
    window.addEventListener('resize', place);
    list.addEventListener('scroll', () => { if (!desktop()) place(); }, { passive: true });
    viewer.addEventListener('slideChanged', place);
    new MutationObserver(place).observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });
    window.addEventListener('load', place);

    nav.querySelectorAll('[data-dir]').forEach((btn) => btn.addEventListener('click', () => {
      const all = items(); if (all.length < 2) return;
      const next = (current() + Number(btn.dataset.dir) + all.length) % all.length;
      const target = all[next];
      gallery.setActiveMedia(target.dataset.mediaId, false);
      if (!desktop()) {
        const want = target.offsetLeft;
        list.scrollTo({ left: want, behavior: 'smooth' });
        setTimeout(() => { if (Math.abs(list.scrollLeft - want) > 4) list.scrollLeft = want; }, 350);
      }
      setTimeout(place, 50);
    }));
  };
  const boot = () => document.querySelectorAll('[data-bw-gal-nav]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
  new MutationObserver(boot).observe(document.body, { childList: true, subtree: true });
})();
